import './styles/App.css';
import './styles/Variables.css'; 
import './styles/ResolutionControl.css';
import './styles/FormElements.css';
import './styles/Navigation.css';
import './styles/Fonts.css';
import './styles/NotificationDropdown.css';
import './styles/CopilotElements.css';
import './styles/Cards.css';
import './styles/Buttons.css';
import './styles/GenBIStudio.css';
import './styles/DashboardView.css';
import './styles/CustomElements.css';
import './styles/AdminDashboard.css';

import { BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';



// IAM auth components
import Login from './components/iamConsole/iamAuth/Login.jsx';
import ConfirmNewPassword from './components/iamConsole/iamAuth/ConfirmNewPassword.jsx';
import ForgotPassword from './components/iamConsole/iamAuth/ForgotPassword.jsx';
import ResetPassword from './components/iamConsole/iamAuth/ResetPassword.jsx';
import AuthorizedRoute from './components/iamConsole/iamAuth/AuthorizedRoute.jsx';
import AuthorizedLoginRoute from './components/iamConsole/iamAuth/AuthorizedLoginRoute.jsx';

// IAM Components
import UnstructuredThreadManagement from './components/iamConsole/threads/UnstructuredThreadManagement.jsx';
import DataFabricManagement from './components/iamConsole/dataFabrics/DataFabricManagement.jsx';
import GenbiDashboard from './components/iamConsole/genbi/GenbiDashboard.jsx'; 

// Admin components
import AdminAuthorizedRoute from './components/administration/administrationAuth/AdminAuthorizedRoute.jsx';
import AdminAuthorizedLoginRoute from './components/administration/administrationAuth/AdminAuthorizedLoginRoute.jsx';
import AdminLogin from './components/administration/administrationAuth/AdminLogin.jsx';
import AdminConfirmNewPassword from './components/administration/administrationAuth/AdminConfirmNewPassword.jsx';
import AdminForgotPassword from './components/administration/administrationAuth/AdminForgotPassword.jsx';
import AdminResetPassword from './components/administration/administrationAuth/AdminResetPassword.jsx';
import AdminDashboard from './components/administration/administrarionServices/AdminDashboard.jsx';
import AdminPermissionSetManagement from './components/administration/administrarionServices/AdminPermissionSetManagement.jsx';
import AdminIamUserManagement from './components/administration/administrarionServices/AdminIAMUserManagement.jsx';
import AdminTransferHistory from './components/administration/administrarionServices/AdminTransferHistory.jsx';
import LlmTraces from './components/administration/administrarionServices/LlmTraces.jsx';

//Global
import UserGuide from './components/globalComponents/UserGuide.jsx';
import { PermissionsProvider } from './components/utils/PermissionsContext';
import { SHOW_PERMISSION_SETS } from './components/administration/administrationNavigation/AdminConsoleNavigation.jsx';

const App = () => {
  return (

    <Router>
      <PermissionsProvider>
      <Routes>
        <Route path="/" element={<AuthorizedLoginRoute element={Login}/>} />
        <Route path="/admin-login" element={<AdminAuthorizedLoginRoute element={AdminLogin}/>} />
        <Route path="/admin-confirm-new-password" element={<AdminConfirmNewPassword />} /> 
        <Route path="/admin-forgot-password" element={<AdminForgotPassword />} />
        <Route path="/admin-reset-password" element={<AdminResetPassword />} />

        <Route path="/admindashboard" element={<AdminAuthorizedRoute element={AdminDashboard}/>} />
        <Route path="/admin-manage-permission-sets" element={SHOW_PERMISSION_SETS ? <AdminAuthorizedRoute element={AdminPermissionSetManagement}/> : <Navigate to="/admindashboard" replace />} />
        <Route path="/admin-manage-iam-users" element={<AdminAuthorizedRoute element={AdminIamUserManagement}/>} />
        <Route path="/admin-transfer-history" element={<AdminAuthorizedRoute element={AdminTransferHistory}/>} />
        <Route path="/admin-llm-traces" element={<AdminAuthorizedRoute element={LlmTraces}/>} />
        <Route
          path="/admin-user-guide" 
          element={<AdminAuthorizedRoute element={() => <UserGuide consoleType="admin-console" />} />} 
        />


        <Route path="/login" element={<AuthorizedLoginRoute element={Login}/>} />
        <Route path="/confirm-new-password" element={<ConfirmNewPassword />} /> 
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="/dashboard" element={<AuthorizedRoute element={DataFabricManagement} />} />  
        <Route path="/data-manager" element={<AuthorizedRoute element={UnstructuredThreadManagement} />} />
        <Route path="/unstructured-threads" element={<Navigate to="/data-manager" replace />} />

        <Route path="/hta-dossier" element={<AuthorizedRoute element={GenbiDashboard} />} /> 

         <Route 
          path="/iam-user-guide" 
          element={<AuthorizedRoute element={() => <UserGuide consoleType="iam-console" />} />} 
        />
        <Route path="/index.html" element={<Navigate to="/" replace />} />
        {/* Add other routes as needed */}
      </Routes>
      </PermissionsProvider>
    </Router>
  );
};

export default App;
